/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown>, name: NonNullable<unknown> }} Directory_Tool_Discount_AriaInputs */

const en_directory_tool_discount_aria = /** @type {(inputs: Directory_Tool_Discount_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Copy discount code ${i?.code} for ${i?.name}`)
};

const zh_directory_tool_discount_aria = /** @type {(inputs: Directory_Tool_Discount_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`复制 ${i?.name} 的优惠码 ${i?.code}`)
};

/**
* | output |
* | --- |
* | "Copy discount code {code} for {name}" |
*
* @param {Directory_Tool_Discount_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tool_discount_aria = /** @type {((inputs: Directory_Tool_Discount_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tool_Discount_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tool_discount_aria(inputs)
	return zh_directory_tool_discount_aria(inputs)
});
export { directory_tool_discount_aria as "directory.tool.discount_aria" }